export const version = "random/5.0.7";
//# sourceMappingURL=_version.js.map